import { change } from 'redux-form';
import { loading, success, handleErrorException } from 'State/actions';
import { UPDATE_OPEN_ORDERS_FORM_NAME } from 'Common/FormEnum';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import * as types from './types';

export const getSiteGroupData = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SITE_GROUP_DATA_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `AssignEntities/GetSiteGroups`
      );
      dispatch(
        success(
          types.SITE_GROUP_DATA_LIST,
          response.data.Data.Data ? response.data.Data.Data : []
        )
      );
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching site group data. Please try again.',
      };
      dispatch(
        handleErrorException(
          err,
          types.SITE_GROUP_DATA_LIST_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.SITE_GROUP_DATA_LOADING, false));
    }
  };
};

export const getWarehouseKitchenData = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SITE_GROUP_DATA_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(`sitemaster`);
      dispatch(
        success(
          types.WAREHOUSE_KITCHEN_DATA_LIST,
          response.data.Data ? response.data.Data : []
        )
      );
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching warehouse/kitchen group data. Please try again.',
      };
      dispatch(
        handleErrorException(
          err,
          types.WAREHOUSE_KITCHEN_DATA_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.SITE_GROUP_DATA_LOADING, false));
    }
  };
};

export const getItemList = (deliveryDT, orderType) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ITEM_DATA_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `UpdateOpenOrders/GetItemsToUpdateOpenOrder/${deliveryDT}/${orderType}`
      );

      dispatch(
        success(
          types.ITEM_DATA_LIST,
          response.data.Data ? response.data.Data : []
        )
      );
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching item list. Please try again.',
      };
      dispatch(handleErrorException(err, types.ITEM_DATA_ERROR, defaultError));
    } finally {
      dispatch(loading(types.ITEM_DATA_LOADING, false));
    }
  };
};

export const getOpenOrderData = requestObj => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.OPEN_ORDER_DATA_LOADING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'UpdateOpenOrders/GetOpenOrders',
        requestObj
      );

      dispatch(
        success(
          types.OPEN_ORDER_DETAIL_DATA,
          response.data.Data ? response.data.Data : []
        )
      );
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching order details. Please try again.',
      };
      dispatch(
        handleErrorException(
          err,
          types.OPEN_ORDER_UPDATE_DETAIL_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.OPEN_ORDER_DATA_LOADING, false));
    }
  };
};

export const checkAllRow = (checkAll, currentRows) => {
  return {
    type: types.OPEN_ORDER_CHECKALL_DATA,
    payload: { checkAll, currentRows },
  };
};

export const checkCurrentRow = item => {
  return {
    type: types.OPEN_ORDER_UPDATE_DATA,
    payload: item,
  };
};

export const saveUpdateOrder = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SUBMITTING_OPEN_ORDER_LOADING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate(
        'UpdateOpenOrders/WriteOpenOrders',
        model
      );
      dispatch(success(types.OPEN_ORDER_UPDATE_DETAIL_SUBMIT));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching order details. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.OPEN_ORDER_UPDATE_DETAIL_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.SUBMITTING_OPEN_ORDER_LOADING, false));
    }
  };
};
export const changeValue = (index, col, val, qtyPerUnit) => {
  return {
    type: types.CHANGE_ROW_VALUE,
    payload: { index, col, val, qtyPerUnit },
  };
};

export const resetOpenOrderTable = () => {
  return {
    type: types.OPEN_ORDER_DETAIL_DATA,
    payload: [],
  };
};

export const clearRunningTotal = () => {
  return {
    type: types.CLEAR_RUNNING_TOTAL,
    payload: [],
  };
};

export const calculateRemainingQty = (
  index,
  col,
  val,
  qtyPerUnit,
  unitValue,
  secondaryUnitValue,
  isTypeOptionSelected
) => {
  return {
    type: types.CALCULATE_REMAINING_QTY,
    payload: {
      index,
      col,
      val,
      qtyPerUnit,
      unitValue,
      secondaryUnitValue,
      isTypeOptionSelected,
    },
  };
};

export const setShowFlag = () => {
  return {
    type: types.SET_SHOW_FLAG,
    payload: false,
  };
};

export const setRemainingItemValue = (
  secondaryUnitVal,
  unitVal,
  qtyPerUnitVal
) => {
  return {
    type: types.SET_REMAINING_VALUE,
    payload: { secondaryUnitVal, unitVal, qtyPerUnitVal },
  };
};

export const changeDropDownData = (dropDownName, data) => {
  return change(UPDATE_OPEN_ORDERS_FORM_NAME, dropDownName, data);
};

export const clearError = () => {
  return {
    type: types.CLEAR_OPEN_ORDER_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/updateopenorders/action.js